import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'bo-delete-confirm-dialog',
  standalone: true,
  imports: [TranslateModule, CommonModule, DialogModule, FormsModule],
  templateUrl: './delete-confirm-dialog.component.html',
  styleUrl: './delete-confirm-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeleteConfirmDialogComponent {
  @Input() visible = false;
  @Input() closing = false;
  @Input() restoreWithoutTransition = false;
  @Input() confirmed = false;
  @Input() targetLabel: 'group' | 'subgroup' | 'activity' = 'group';
  @Input() targetName = '';
  @Input() errorMessage = '';

  @Output() closed = new EventEmitter<void>();
  @Output() hidden = new EventEmitter<void>();
  @Output() confirmedChange = new EventEmitter<boolean>();
  @Output() deleted = new EventEmitter<void>();

  onConfirmedChange(value: boolean) {
    this.confirmedChange.emit(value);
  }

  close() {
    this.closed.emit();
  }

  confirm() {
    this.deleted.emit();
  }

  onHidden() {
    this.hidden.emit();
  }
}
